import axios from "../axios";

export const createTicket = (data) => {
  return axios.post("api/Ticket/create", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Get Tickets 
// Harshada Bhavsar
export const getTickets = async (status) => {
  return axios.get(`api/Ticket/getTickets/${status}`);
};


// Approve Tickets 
// Harshada Bhavsar - 17/11/2025
export const approveTicket = (data) => {
  return axios.post("api/Ticket/Approve", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Reject  Tickets 
// Harshada Bhavsar - 17/11/2025
export const rejectTicket = (data) => {
  return axios.post("/api/Ticket/Reject", data, {
    headers: { "Content-Type": "application/json" },
  });
};


// Assign  Tickets 
// Harshada Bhavsar - 17/11/2025
export const assignTicket = (data) => {
  return axios.post("/api/Ticket/Assign", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// In-Progress  Tickets 
// Harshada Bhavsar - 18/11/2025
export const InProgressTicket = (data) => {
  return axios.post("/api/Ticket/MarkInProgress", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Mark Ready for Review  Tickets 
// Harshada Bhavsar - 18/11/2025
export const ReadyForReviewTicket = (data) => {
  return axios.post("/api/Ticket/MarkReadyForReview", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Assign to reviewer Tickets 
// Harshada Bhavsar - 18/11/2025
export const AssignToReviewerTicket = (data) => {
  return axios.post("/api/Ticket/AssignToReviewer", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Mark Ready for Review  Tickets 
// Harshada Bhavsar - 18/11/2025
export const ReviewInProgressTicket = (data) => {
  return axios.post("/api/Ticket/MarkReviewInProgress", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Reviewed Tickets 
// Harshada Bhavsar - 18/11/2025
export const ReviewedTicket = (data) => {
  return axios.post("/api/Ticket/MarkReviewed", data, {
    headers: { "Content-Type": "application/json" },
  });
};


// Reopen Tickets 
// Harshada Bhavsar - 18/11/2025
export const ReopenTicket = (data) => {
  return axios.post("/api/Ticket/Reopen", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Closed Tickets 
// Harshada Bhavsar - 18/11/2025
export const ClosedTicket = (data) => {
  return axios.post("/api/Ticket/Close", data, {
    headers: { "Content-Type": "application/json" },
  });
}


// Hold Tickets 
// Harshada Bhavsar - 19/11/2025
export const HoldTicket = (data) => {
  return axios.post("/api/Ticket/Hold", data, {
    headers: { "Content-Type": "application/json" },
  });
}

// Resume Tickets 
// Harshada Bhavsar - 19/11/2025
export const ResumeTicket = (data) => {
  return axios.post("/api/Ticket/Resume", data, {
    headers: { "Content-Type": "application/json" },
  });
}

// GET Ticket History
//Harshada Bhavsar - 20/11/2025
export const getTicketHistory = (TicketNo) => {
  return axios.get(`/api/Ticket/history/${TicketNo}`);
};


// Mark Viewed Ticket
//Harshada Bhavsar - 04/12/2025
export const MarkViewedTicket = (TicketUID ) => {
  return axios.get(`/api/Ticket/MarkViewed/${TicketUID}`);
};

